import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuFunctionalityEnum } from 'src/app/shared/menu/menu.functionality.enum';
import { MenuModuleEnum } from 'src/app/shared/menu/menu.module.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { FlowchartService } from 'src/app/shared/services/API/self-triage/flowchart.service';
import { QuestionSelectService } from 'src/app/shared/services/API/self-triage/question-select.service';
import { Masks, MaskService } from 'src/app/shared/services/mask.service';
import { QuestionModel } from 'src/app/shared/services/models/self-triage/question.model';
import { FlowchartRequest } from 'src/app/shared/services/requests/self-triage/flowchart.request';
import { AgeStruct } from 'src/app/shared/services/structs/risk-classification/age.struct';

@Component({
  selector: 'app-self-triage-flowchart-register',
  templateUrl: './self-triage-flowchart-register.component.html',
  styleUrls: ['./self-triage-flowchart-register.component.css']
})
export class SelfTriageFlowchartRegisterComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private maskService: MaskService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private flowchartService: FlowchartService,
    private questionService: QuestionSelectService,
  ) { }

  public menuModuleEnum: MenuModuleEnum = MenuModuleEnum.consulting;
  public menuFunctionalityEnum: MenuFunctionalityEnum = MenuFunctionalityEnum.consulting_flowchart;

  public model: FormGroup;
  public isLoading: boolean = false;
  public isFirstLoading: boolean;
  public isUpdate: boolean = false;

  public masks: Masks = this.maskService.getMasks();;
  public questions: QuestionModel[];
  public idFlowchart: number = null;
  public isCopy: boolean;
  public question: number[];
  public questionsSelected: QuestionModel[];
  public flowchartRequest: FlowchartRequest = new FlowchartRequest();;
  public selectQuestion: number[];

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.paramMap.get('idFlowchart')) {
      this.idFlowchart = parseInt(this.activatedRoute.snapshot.paramMap.get('idFlowchart'));
      this.populateQuestions(this.idFlowchart);
    } else {
      this.populateQuestions(null);
    }

    this.isUpdate = this.idFlowchart ? true : false;

    this.model = this.formBuilder.group({
      flowchartName: ['', [Validators.required]],
      flowchartDescription: [''],
      flowchartMinAge: ['', [Validators.required]],
      flowchartMaxAge: ['', [Validators.required]],
      question: [''],
    });

    if (this.idFlowchart)
      this.populateFlowchartData();
  }

  submit() {
    if (this.isLoading) {
      return;
    }
    if (!this.model.valid) {
      this.alertService.show('Erro', "Todos os campos em vermelho devem ser corretamente preenchidos.", AlertType.error);
      return;
    }

    this.isLoading = true;

    this.flowchartRequest.questionsSelected = this.model.get('question').value == 0 ? null : this.model.get('question').value;
    this.flowchartRequest.name = this.model.get('flowchartName').value;
    this.flowchartRequest.description = this.model.get('flowchartDescription').value;
    this.flowchartRequest.minAgeStruct = this.formatDateToSave(this.model.get('flowchartMinAge').value);
    this.flowchartRequest.maxAgeStruct = this.formatDateToSave(this.model.get('flowchartMaxAge').value);

    if (this.isUpdate)
      this.updateTemplate();
    else
      this.createTemplate();
  }

  formatDateToSave(age: string): AgeStruct {
    let ageStruct = new AgeStruct();
    if (age) {
      let date = age.split("a");
      ageStruct.years = parseInt(date[0]);
      date = date[1].split("m");
      ageStruct.months = parseInt(date[0]);
      date = date[1].split("d");
      ageStruct.days = parseInt(date[0]);
    }
    return ageStruct;
  }

  populateQuestions(idFlowchart: number) {
    this.questionService.listQuestion(idFlowchart).subscribe((response) => {
      if (response.isError) {
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      this.questions = response.listQuestion;
    },
      (error) => {
        console.log(error)
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      });
  }

  getAgeFormatted(age: AgeStruct): string {
    let years = (age.years ? age.years.toString().padStart(3, '0') : '000') + 'a';
    let months = (age.months ? age.months.toString().padStart(2, '0') : '00') + 'm';
    let days = (age.days ? age.days.toString().padStart(2, '0') : '00') + 'd';
    return years + months + days;
  }

  validateAge(ctrlName?: 'min' | 'max'): boolean {
    const minCtrl = this.model.get('flowchartMinAge');
    const maxCtrl = this.model.get('flowchartMaxAge');

    // Função para validar formato e consistência
    const parseAge = (value: string, ctrl: AbstractControl): { years: number; months: number; days: number } | null => {
      if (!value) return null;

      const regex = /(\d{3})a(\d{2})m(\d{2})d/;
      const match = value.match(regex);

      if (!match) {
        this.alertService.show('Erro', 'Formato inválido. Use o formato 000a00m00d.', AlertType.error);
        ctrl.setErrors({ invalidFormat: true });
        return null;
      }

      const years = parseInt(match[1]);
      const months = parseInt(match[2]);
      const days = parseInt(match[3]);

      // Se há anos, mês e dia não podem ser zero
      if (years > 0 && (months === 0 || days === 0)) {
        this.alertService.show('Erro', 'Se houver anos, mês e dia não podem ser zero.', AlertType.error);
        ctrl.setErrors({ invalidAgeStructure: true });
        return null;
      }

      if (years !== 0 && months < 1 || months > 12) {
        this.alertService.show('Erro', 'O mês deve estar entre 01 e 12.', AlertType.error);
        ctrl.setErrors({ invalidMonth: true });
        return null;
      }

      // Verifica limite de dias conforme mês
      const isLeapYear = (year: number) =>
        year !== 0 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);

      const monthDays = [31, isLeapYear(years) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      const maxDays = monthDays[months - 1];

      if (years !== 0 && days < 1 || days > maxDays) {
        this.alertService.show('Erro', `O mês ${months.toString().padStart(2, '0')} tem no máximo ${maxDays} dias.`, AlertType.error);
        ctrl.setErrors({ invalidDays: true });
        return null;
      }

      ctrl.setErrors(null);
      return { years, months, days };
    };

    const minAge = parseAge(minCtrl?.value, minCtrl!);
    const maxAge = parseAge(maxCtrl?.value, maxCtrl!);

    // Se apenas um campo foi alterado (blur)
    if (ctrlName === 'min' && minAge && maxCtrl?.value) {
      this.validateMinMax(minAge, maxAge, minCtrl!, maxCtrl!);
    } else if (ctrlName === 'max' && maxAge && minCtrl?.value) {
      this.validateMinMax(minAge, maxAge, minCtrl!, maxCtrl!);
    }

    return true;
  }

  private validateMinMax(
    minAge: { years: number; months: number; days: number } | null,
    maxAge: { years: number; months: number; days: number } | null,
    minCtrl: AbstractControl,
    maxCtrl: AbstractControl
  ) {
    if (!minAge || !maxAge) return;

    // Compara idades
    const minDays = this.convertToDays(minAge);
    const maxDays = this.convertToDays(maxAge);

    if (maxDays < minDays) {
      this.alertService.show('Erro', 'A idade máxima não pode ser menor que a idade mínima.', AlertType.error);
      maxCtrl.setErrors({ invalidRange: true });
    } else {
      maxCtrl.setErrors(null);
    }
  }

  private convertToDays(age: { years: number; months: number; days: number }): number {
    return age.years * 365.25 + age.months * 30.44 + age.days;
  }

  populateFlowchartData() {
    this.flowchartService.getFlowchart(this.idFlowchart).subscribe((response) => {
      if (response.isError) {
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      this.model.get('question').setValue(response.questions ? response.questions.idQuestion : 0);
      this.model.get('flowchartName').setValue(response.flowchart.name);
      this.model.get('flowchartDescription').setValue(response.flowchart.description);
      this.model.get('flowchartMinAge').setValue(this.getAgeFormatted(response.flowchart.minAgeStruct));
      this.model.get('flowchartMaxAge').setValue(this.getAgeFormatted(response.flowchart.maxAgeStruct));
    },
      (error) => {
        console.log(error)
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      });
  }

  updateTemplate() {
    this.flowchartService.updateFlowchart(this.idFlowchart, this.flowchartRequest).subscribe((response) => {
      if (response.isError) {
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }

      this.alertService.show('Sucesso', "Informações salvas com sucesso", AlertType.success);
      this.isLoading = false;

      this.router.navigate(['/consulting/self-triage-flowchart']);
    },
      (error) => {
        console.log(error)
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      });
  }

  createTemplate() {
    this.flowchartService.createFlowchart(this.flowchartRequest).subscribe((response) => {
      if (response.isError) {
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }

      this.alertService.show('Sucesso', "Informações salvas com sucesso", AlertType.success);
      this.isLoading = false;

      this.router.navigate(['/consulting/self-triage-flowchart']);

    },
      (error) => {
        console.log(error)
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      });
  }

  selectedQuestion(event: any) {
    this.selectQuestion = event.value;
  }
}